import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchComponent } from './search/search.component';
import { ArticleComponent } from './article/article.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Client } from './services/api';
import { HttpClientModule } from '@angular/common/http';
import { AngularGradientProgressbarComponent } from './shared/components/gradient-progressbar/angular-gradient-progressbar.component';

@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    ArticleComponent,
    AngularGradientProgressbarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [Client],
  bootstrap: [AppComponent],
})
export class AppModule {}
